import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, Calendar } from 'lucide-react';

const CourseCard = ({ course, onClick, className = '' }) => {
  const levelColors = {
    A1: 'from-emerald-50 to-emerald-100 border-emerald-200',
    A2: 'from-cyan-50 to-cyan-100 border-cyan-200',
    B1: 'from-blue-50 to-blue-100 border-blue-200',
    B2: 'from-purple-50 to-purple-100 border-purple-200',
    C1: 'from-pink-50 to-pink-100 border-pink-200',
    C2: 'from-red-50 to-red-100 border-red-200'
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02, y: -4 }}
      transition={{ duration: 0.2 }}
      className={`cursor-pointer ${className}`}
      onClick={onClick}
      data-testid={`course-card-${course.level}`}
    >
      <div
        className={`relative overflow-hidden rounded-2xl border-2 bg-gradient-to-br ${
          levelColors[course.level] || 'from-gray-50 to-gray-100 border-gray-200'
        } p-6 h-full shadow-lg hover:shadow-2xl transition-all duration-300`}
      >
        <div className="absolute top-4 right-4">
          <span className="text-5xl font-bold text-black/5">{course.level}</span>
        </div>

        <div className="relative z-10">
          <div className="mb-4">
            <span className="inline-block px-4 py-1 bg-black text-white text-xs font-mono uppercase tracking-wider rounded-full">
              {course.level}
            </span>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-3">{course.title}</h3>
          <p className="text-gray-600 mb-6 line-clamp-2">{course.description}</p>

          <div className="space-y-2 mb-6">
            <div className="flex items-center text-sm text-gray-700">
              <Clock className="w-4 h-4 mr-2" />
              <span>{course.duration}</span>
            </div>
            <div className="flex items-center text-sm text-gray-700">
              <Calendar className="w-4 h-4 mr-2" />
              <span>{course.schedule}</span>
            </div>
          </div>

          <div className="flex items-center justify-between pt-4 border-t border-gray-300">
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-gray-900">{course.price_pi}</span>
              <span className="text-lg font-medium text-purple-600">π</span>
            </div>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-6 py-2 bg-black text-white rounded-lg font-medium hover:bg-gray-800 transition-colors"
              data-testid={`enroll-btn-${course.level}`}
            >
              Enroll Now
            </motion.button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CourseCard;
